import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import CommonOrderComponent from "~/components/parking/Checkout/CommonOrderComponent"
import { PAYMENT_PROVIDERS } from "~/utilities/constants";


@inject(all => ({
  totalRobotSelectedPayableAmount: all.store.robotTickets.selectedFineAmount,
  feeForRobotSelectedPayable: all.store.robotTickets.feeForSelectedFineAmount,
  totalRobotServiceFee: all.store.robotTickets.totalServiceFee,
  payRobotSubtotal: all.store.robotTickets.paySubtotal,
  userCredits: all.store.auth.user.credits,
  paymentProcessor: all.store.payment.paymentProcessor,
}))

@observer
class RobotOrderCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      totalSelectedPayableAmount:  props.totalRobotSelectedPayableAmount,
      totalServiceFee: props.totalRobotServiceFee,
      feeForSelectedPayable: props.feeForRobotSelectedPayable,
      paySubtotal: props.payRobotSubtotal
    }
  }

  render() {
    const {
      userCredits,
      paymentProcessor,
    } = this.props
    let finalPaySubTotal = this.state.paySubtotal
    let finalUserCredits= userCredits
    if (paymentProcessor === PAYMENT_PROVIDERS.evervault && userCredits > 0) {
      finalPaySubTotal -=  Math.min(this.state.feeForSelectedPayable, userCredits) - userCredits
      finalUserCredits = Math.min(this.state.feeForSelectedPayable, userCredits)
    }
    return (
      <>
        {paymentProcessor === PAYMENT_PROVIDERS.evervault ? (
          <CommonOrderComponent
            payableAmount={this.state.totalSelectedPayableAmount}
            serviceFee={this.state.feeForSelectedPayable}
            processingFee={this.state.totalServiceFee}
            userCredits={finalUserCredits}
            paySubTotal={finalPaySubTotal}
            paymentProcessor={paymentProcessor}
          />
        ) : (
          <CommonOrderComponent
            payableAmount={this.state.totalSelectedPayableAmount}
            serviceFee={this.state.totalServiceFee}
            processingFee={this.state.feeForSelectedPayable}
            userCredits={userCredits}
            paySubTotal={finalPaySubTotal}
            paymentProcessor={paymentProcessor}
          />
        )}
      </>
    )
  }
}

export default RobotOrderCard
